exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2014 - 2024 Comparatio USA LLC.\n */\n.ellipsed-text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; }\n.wrap {\n  white-space: pre-wrap; }\n.overlayMessage {\n  position: relative;\n  z-index: 999;\n  background-color: #f86c6b;\n  color: #fff;\n  border: 3px solid #fff;\n  padding: 5px 10px;\n  left: 35%;\n  top: 20%;\n  max-width: 375px;\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/teamwork-reports/tickets-replies/tickets-replies.component.scss
// module id = ../../../../../angular/app/views/teamwork-reports/tickets-replies/tickets-replies.component.scss
// module chunks = main